import { persistStore, persistReducer } from 'redux-persist';
import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';

import { rootReducer } from './rootReducer';
import { usersApi } from '@api/users';
import { rolesApi } from '@api/roles';
import { dashbordsApi } from '@api/dashboards';
import { permissionsApi } from '@api/permissions';
import { organisationsApi } from '@api/organisations';
import { chatsApi } from '@api/chats';
import { customerCreditBalanceApi } from '@api/creditBalance';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'app'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REGISTER'],
        ignoredPaths: ['register'],
      },
    })
      .concat(usersApi.middleware)
      .concat(rolesApi.middleware)
      .concat(dashbordsApi.middleware)
      .concat(organisationsApi.middleware)
      .concat(chatsApi.middleware)
      .concat(permissionsApi.middleware)
      .concat(customerCreditBalanceApi.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
